// 园区信息
const parkInformationJurisdiction = [
  { id: '001001001', label: '修改园区信息', children: [] }
]

// 园区公告
const parkNoticeJurisdiction = [
  { id: '001002001', label: '添加', children: [] },
  { id: '001002002', label: '删除', children: [] },
  { id: '001002003', label: '修改', children: [] }
]

// 园区资讯
// const parkZxJurisdiction = [
//   { id: '001002005', label: '添加', children: [] },
//   { id: '001002007', label: '修改', children: [] },
//   { id: '001002006', label: '删除', children: [] }
// ]

// 政策解读
// const partyInformationJurisdiction = [
//   { id: '001015001', label: '添加', children: [] },
//   { id: '001015002', label: '修改', children: [] },
//   { id: '001015003', label: '删除', children: [] }
// ]

// 党建引领
// const partyPolicyJurisdiction = [
//   { id: '001016001', label: '添加', children: [] },
//   { id: '001016002', label: '修改', children: [] },
//   { id: '001016003', label: '删除', children: [] }
// ]

// 房屋管理
const housingManagementJurisdiction = [
  { id: '001003001', label: '添加房间', children: [] },
  { id: '001003002', label: '删除房间', children: [] },
  { id: '001003003', label: '修改房间', children: [] },
  { id: '001003004', label: '导入房间', children: [] },
  { id: '001003005', label: '导出房间', children: [] },
  { id: '001003007', label: '添加楼栋', children: [] },
  { id: '001003008', label: '删除楼栋', children: [] },
  { id: '001003009', label: '修改楼栋', children: [] },
  { id: '001003010', label: '修改楼层面积', children: [] },
  { id: '001003011', label: '删除楼层', children: [] }
]

// 个人承租
const businessManagementJurisdiction = [
  { id: '001004001', label: '添加个人承租', children: [] },
  { id: '001004002', label: '删除个人承租', children: [] },
  { id: '001004003', label: '修改个人承租', children: [] },
  { id: '001004004', label: '分配房源', children: [] },
  // { id: '001004005', label: '导入住户', children: [] },
  // { id: '001004006', label: '历史住户', children: [] }
]

// 单位承租
const enterpriseContractingJurisdiction = [
  { id: '001004006', label: '添加单位承租', children: [] },
  { id: '001004007', label: '删除单位承租', children: [] },
  { id: '001004008', label: '修改单位承租', children: [] },
  { id: '001004009', label: '分配房源', children: [] },
  // { id: '001004005', label: '导入住户', children: [] },
  // { id: '001004006', label: '历史住户', children: [] }
]

// 人员管理
const personManagementJurisdiction = [
  { id: '001005001', label: '添加人员', children: [] },
  { id: '001005002', label: '删除人员', children: [] },
  { id: '001005003', label: '修改人员', children: [] },
  { id: '001005004', label: '导入人员', children: [] },
  { id: '001005005', label: '导出人员', children: [] }
]

// 子账号管理
const accountManagementJurisdiction = [
  { id: '001007001', label: '添加子账号', children: [] },
  { id: '001007002', label: '删除子账号', children: [] },
  { id: '001007003', label: '修改子账号', children: [] }
]

// 角色管理
const roleManagementJurisdiction = [
  { id: '001008001', label: '添加角色', children: [] },
  { id: '001008002', label: '删除角色', children: [] },
  { id: '001008003', label: '修改角色', children: [] }
]

const configManagementBannerJurisdiction = [
  { id: '001011001', label: '添加Banner', children: [] },
  { id: '001011002', label: '修改Banner', children: [] },
  { id: '001011003', label: '删除Banner', children: [] }
]

// 导航栏配置
const configManagementNavJurisdiction = [
  { id: '001012001', label: '修改导航栏配置', children: [] }
]

// 审批配置
const configManagementApprovalJurisdiction = [
  { id: '001013001', label: '修改审批配置', children: [] }
]

// Boss看板配置
const configManagementBossJurisdiction = [
  { id: '001014001', label: '添加', children: [] },
  { id: '001014002', label: '删除', children: [] }
]

// 人脸授权配置
const configManagementFaceJurisdiction = [
  { id: '001017001', label: '删除', children: [] }
]

// 资源中心
const basicServicesJurisdictionChildren = [
  {
    id: '001001000',
    label: '公寓信息',
    routerName: 'yq-information',
    children: parkInformationJurisdiction
  },
  {
    id: '001002000',
    label: '公寓公告',
    routerName: 'yq-notice-management',
    children: parkNoticeJurisdiction
  },
  // {
  //   id: '001002004',
  //   label: '公寓资讯',
  //   routerName: 'yq-zx-manage',
  //   children: parkZxJurisdiction
  // },
  // {
  //   id: '001015000',
  //   label: '政策解读',
  //   routerName: 'party-information-manage',
  //   children: partyInformationJurisdiction
  // },
  // {
  //   id: '001016000',
  //   label: '党建引领',
  //   routerName: 'party-policy-manage',
  //   children: partyPolicyJurisdiction
  // },
  {
    id: '001003000',
    label: '房屋管理',
    routerName: 'housing-management',
    children: housingManagementJurisdiction
  },
  {
    id: '001004000',
    label: '个人承租',
    routerName: 'lessee-management',
    children: businessManagementJurisdiction
  },
  {
    id: '001004005',
    label: '单位承租',
    routerName: 'business-management',
    children: enterpriseContractingJurisdiction
  },
  {
    id: '001005000',
    label: '人员管理',
    routerName: 'person-management',
    children: personManagementJurisdiction
  },
  {
    id: '001007000',
    label: '子账号管理',
    routerName: 'account-management',
    children: accountManagementJurisdiction
  },
  {
    id: '001008000',
    label: '角色管理',
    routerName: 'role-management',
    children: roleManagementJurisdiction
  },
  {
    id: '001011000',
    label: 'Banner配置',
    routerName: 'banner-manage',
    children: configManagementBannerJurisdiction
  },
  {
    id: '001012000',
    label: '导航栏配置',
    routerName: 'navigation-bar-config',
    children: configManagementNavJurisdiction
  },
  {
    id: '001013000',
    label: '审批配置',
    routerName: 'resource-approval-manage',
    children: configManagementApprovalJurisdiction
  },
  {
    id: '001014003',
    label: 'Boss看板配置',
    routerName: 'boss-bulletin-board',
    children: configManagementBossJurisdiction
  },
  {
    id: '001017000',
    label: '人脸授权配置',
    routerName: 'boss-bulletin-board',
    children: configManagementFaceJurisdiction
  },
  {
    id: '001010000',
    label: '操作日志',
    routerName: 'resource-center-log',
    children: []
  }
]

const basicServicesJurisdiction = {
  id: '001',
  label: '资源中心',
  children: basicServicesJurisdictionChildren
}

export { basicServicesJurisdiction }



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/basicServicesJurisdiction.js